<template>
  <div id="app" class="col-md-5 col-xs-12 col-sm-12 col-12">
    <h1 class="big-title text-left-desktop">{{ $t('m26') }}</h1>
    <p class="description-page md-text-center">
      {{ $t('m27') }}
    </p>
  </div>
</template>

<script>
import ALink from '@/components/ui/ALink';
import { validator } from '@/mixins/validator.js';

export default {
  components: {
    ALink,
  },
  mixins: [validator],
  data() {
    return {
      loading: false,
      form: {
        token: {
          value: '',
          error: '',
          rules: [],
        },
      },
    };
  },
  methods: {
    checkForm(e) {
      if (this.validateForm()) {
        this.loading = true;
        this.$store
          .dispatch('register/resetPasswordValidateUser', this.form.token.value)
          .then(resp => {
            if (resp.userId) {
              this.$router.push({
                name: 'NEW_PASSWORD',
                query: { token: this.form.token.value },
              });
            } else {
              this.$toast.error(
                'El token no es válido, inicie el proceso nuevamente',
              );
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
      e.preventDefault();
    },
  },
  mounted() {
    this.form.token.rules = [this.rules.required];
    this.form.token.value = this.$route.query.token || '';
  },
};
</script>
